import Axios from 'axios'
import nextCookie from 'next-cookies'
import envConfig from 'config/env_config'
import * as Sentry from '@sentry/browser'

Axios.defaults.baseURL = envConfig.urlBase

const handleRequest = (request) => {
  if (request.baseURL.includes(process.env.VTEX_FILES_URL)) return request

  const cookies = nextCookie({ req: {} })
  if (cookies.authCookie) {
    request.headers.authorization = cookies.authCookie.replace(/"/g, '')
  }
  if (cookies.checkoutdataaccess) {
    request.headers.checkoutdataaccess = cookies.checkoutdataaccess
  }
  if (cookies.cobasiSession && cookies.cobasiSession !== 'null') {
    request.headers['X-Cobasi-Session'] = cookies.cobasiSession
  }
  return request
}

const handleError = error => {
  if (error.response) {
    if (error.response.status === 401) {
      return Promise.reject(error)
    }
    // Melhora a mensagem de erro no Sentry, quando possível.
    // Sempre está como "Error", e isso não é muito útil pra nós.
    error.name = typeof error.response.data === 'string'
      ? error.response.data
      : typeof error.response.data.error === 'string'
        ? error.response.data.error
        : Array.isArray(error.response.data) && (typeof error.response.data[0].error === 'string' || typeof error.response.data[0].message === 'string')
          ? typeof error.response.data[0].error === 'string'
            ? error.response.data[0].error
            : error.response.data[0].message
          : error.name
    Sentry.setExtra('error', error)
    Sentry.setExtra('response', error.response)
    Sentry.setExtra('config', error.response.config)
  }
  Sentry.captureException(error)
  return Promise.reject(error)
}

Axios.interceptors.request.use(request => handleRequest(request))

Axios.interceptors.response.use(response => response, error => handleError(error))

export default Axios
